// extracted by mini-css-extract-plugin
export var container = "recipient_container__P2vjl";
export var names = "recipient_names__A6ie4";
export var recipientsInformation = "recipient_recipientsInformation__y9vcl";